<template>
  <h6
    class="clickable"
    @click="$store.dispatch('favPlaylist', { playlistId })"
    v-b-tooltip.hover
    :title="
      isFavourite
        ? $t('FavIndicator_tooltip_remove')
        : $t('FavIndicator_tooltip_add')
    "
  >
    <a
      :class="{
        fa: true,
        'fa-heart': true,
        'text-light': !isFavourite,
        'text-green': isFavourite,
      }"
      aria-hidden="true"
    />
  </h6>
</template>

<script>
export default {
  name: 'FavIndicator',
  props: ['playlistId', 'isFavourite'],
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/FavIndicator.vue